import { useParams } from 'react-router-dom';

export const ResumeQuoteCompnent = () => {

    const { quotenumber } = useParams();
    return (
        <>
            <div className="resume-quote">
                <h1>Resume Quote</h1>
                <p>This is the resume quote component.</p>
                <p>Quote Number: {quotenumber}</p>
            </div>
        </>
    );

}